import { Instance } from 'mobx-state-tree'
import { GameEntityModelBase } from './GameEntityModel.base'

/* The TypeScript type of an instance of GameEntityModel */
export interface GameEntityModelType extends Instance<typeof GameEntityModel> {}

/* A graphql query fragment builders for GameEntityModel */
export { selectFromGameEntity, gameEntityModelPrimitives, GameEntityModelSelector } from './GameEntityModel.base'

/**
 * GameEntityModel
 */
export const GameEntityModel = GameEntityModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
